<template>
  <div>
    <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntTitulo='"Tratando Nota Fiscal"'
    :cpntLargura='"600px"'

    :cpntOnFecharDialog='cpntFecharDialog'>
      <template slot='conteudo'>
        <div v-if="Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1" class="request-manual-form" :data-time='time'>
          <RF-Componente v-if="formulario.field.hasOwnProperty('acao')" :class="'request-manual-acao'"
            :data-time='time'
            :cpntTamanho='formulario.field.acao.tamanho'
            :cpntModelo='formulario.field.acao.tipo'
            :cpntStatus='formulario.field.acao.status'
            :cpntId='formulario.field.acao.id'
            :cpntClassDivField='formulario.field.acao.classDivField'
            :cpntNome='formulario.field.acao.nome'
            :cpntValue='formulario.field.acao.value'
            :cpntValueRef='formulario.field.acao.valueRef'
            :cpntOptions='formulario.field.acao.options'
            :cpntKeyValue='formulario.field.acao.keyValue'
            :cpntKeyMostra='formulario.field.acao.keyMostra'
            :cpntAutoComplete='formulario.field.acao.autocomplete'
            :cpntDisabled='formulario.field.acao.disabled'
            :cpntMostrar='formulario.field.acao.mostrar'
            :cpntMensagem='formulario.field.acao.mensagem'
            :cpntSelecioneNome='formulario.field.acao.selecioneNome'
            :cpntSelecioneValue='formulario.field.acao.selecioneValue'
            :cpntMensagemTipo='formulario.field.acao.mensagemTipo'
            :cpntAdicinarOption='formulario.field.acao.adicinarOption'
            :cpntMultiple='formulario.field.acao.multiple'
            :cpntAllRegistro='formulario.field.acao.allRegistro'
            :cpntExplica='formulario.field.acao.explica'
            :cpntTabIndex='formulario.field.acao.tabIndex'
            :cpntOptionInicialNome='formulario.field.acao.optionInicialNome'
            :cpntOptionInicialValue='formulario.field.acao.optionInicialValue'

            :cpntOnChange='formulario.field.acao.onChange'
            :cpntOnBlur='formulario.field.acao.onBlur'
            :ref='formulario.field.acao.id'
          ></RF-Componente>

          <RF-Componente v-if="formulario.field.hasOwnProperty('request')" :class="'request-manual-request'"
            :data-time='time'
            :cpntTamanho='formulario.field.request.tamanho'
            :cpntModelo='formulario.field.request.tipo'
            :cpntStatus='formulario.field.request.status'
            :cpntId='formulario.field.request.id'
            :cpntClassDivField='formulario.field.request.classDivField'
            :cpntNome='formulario.field.request.nome'
            :cpntValue='formulario.field.request.value'
            :cpntValueRef='formulario.field.request.valueRef'
            :cpntOptions='formulario.field.request.options'
            :cpntKeyValue='formulario.field.request.keyValue'
            :cpntKeyMostra='formulario.field.request.keyMostra'
            :cpntAutoComplete='formulario.field.request.autocomplete'
            :cpntDisabled='formulario.field.request.disabled'
            :cpntMostrar='formulario.field.request.mostrar'
            :cpntMensagem='formulario.field.request.mensagem'
            :cpntSelecioneNome='formulario.field.request.selecioneNome'
            :cpntSelecioneValue='formulario.field.request.selecioneValue'
            :cpntMensagemTipo='formulario.field.request.mensagemTipo'
            :cpntAdicinarOption='formulario.field.request.adicinarOption'
            :cpntMultiple='formulario.field.request.multiple'
            :cpntAllRegistro='formulario.field.request.allRegistro'
            :cpntExplica='formulario.field.request.explica'
            :cpntTabIndex='formulario.field.request.tabIndex'
            :cpntOptionInicialNome='formulario.field.request.optionInicialNome'
            :cpntOptionInicialValue='formulario.field.request.optionInicialValue'

            :cpntOnChange='formulario.field.request.onChange'
            :cpntOnBlur='formulario.field.request.onBlur'
            :ref='formulario.field.request.id'
          ></RF-Componente>

          <div v-if="Object.keys(buttons).length >= 1" :class="'request-manual-buttons'">
            <RF-Button v-for="(button, chave) in buttons" :key="chave"
              :data-time='time'

              :cpntStatus='button.status' 
              :cpntId='button.id' 
              :cpntTexto='button.texto' 
              :cpntClass='button.class'
              :cpntMostrar='button.mostrar'
              :cpntTabIndex='button.tabIndex'

              @onClickButton='button.onClick'
            ></RF-Button>
          </div>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
  .request-manual-form {
    width: 460px;
    margin: 0px auto;
    text-align: left;
    padding-top: 20px;
  }

  .request-manual-request {
    margin-top: 30px;
  }

  .request-manual-buttons {
    text-align: center;
  }
    .request-manual-buttons > button {
      margin: 20px 10px;
    }
</style>

<script>
  export default {
    props: {
      cpntRefId: {
        required: true
      },
      cpntFecharDialog: {
        required: true
      },
      cpntVendaAcoesProduto: {
        required: true,
        type: Object
      }
    },
    // components: {
    //   'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
    //   'RF-TextArea': () => import('@/components/rf-geral/textarea/RF-TextArea.vue')
    // },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario: {},
        buttons: {},
      }
    },
    mounted: function () {
      this.requestManualIniciar()
    },
    methods: {
      requestManualIniciar: function () {
        // SETA O STATUS DO COMPONENT
        this.requestManualStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA INICIAR OS CAMPOS
        this.requestManualFormularioIniciar()
      },
      requestManualStatusGeral: function (status) {
        // SETA O STATUS DO COMPONENT
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      requestManualFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: '',
          id: 'form-request-manual-',
          field: {},
          startFocus: 'produto'
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // SETA OS OPTIONS DO CAMPO
        var options = [
            { id: 'baixar', nome: 'Baixar XML' },
            { id: 'emitir', nome: 'Emitir XML' },
        ]

        // VERIFICA SE EXISTE O BOTÃO REEMITIR
        if (this.cpntVendaAcoesProduto.reemitir !== '0') {
          options.push({ id: 'baixar_ult_envio', nome: 'Baixar Ultimo XML' })
        }

        // CRIA PARA DIGITAR O PRODUTO
        self.formulario.field = {
          acao: {
            tamanho: 2,
            id: self.formulario.id + '-acao',
            tipo: 'select2',
            nome: 'Ação',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: options,
            // [
            //   { id: 'baixar', nome: 'Capturar XML' },
            //   { id: 'baixar_ult_envio', nome: 'Capturar Ultimo XML' },
            //   { id: 'enviar', nome: 'Enviar XML' },
            // ],
            value: 'baixar',
            onChange: self.requestManualOnChange
          },
          request: {
            tamanho: 1,
            id: self.formulario.id + '-request',
            tipo: 'textarea',
            nome: 'XML Request',
            keyValue: 'id',
            value: '',
            mostrar: false,
            onChange: self.requestManualOnChange
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields
          
          // SETA O BOTÃO DA TELA
          self.buttons = {
            buscar: {
              status: '',
              id: self.formulario.id + '-button-buscar',
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              texto: '',
              tipo: 'texto',
              onClick: self.requestManualCampoBuscarApi
            },
            copiar: {
              status: '',
              id: self.formulario.id + '-button-copiar',
              class: [ 'btn', 'btn-default', 'btn-sm' ],
              texto: 'Copiar',
              tipo: 'texto',
              onClick: function () {
                self.$store.commit('FUN_COPIAR_VALOR', { valor: self.formulario.field.request.value, mensagem: 'WEB [200]: Request copiado para a área de transferência.' })
              }
            }
          }

          // CHAMA A FUNÇÃO PARA VER QUAL CAMPO DEVE MOSTRAR
          self.requestManualCampoMostraOculta()

          // SETA O STATUS PARA O FORMULARIO
          self.requestManualStatusGeral('')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      requestManualOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.formulario.field[index[1]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index[1]].mensagem = ''
        this.formulario.field[index[1]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index[1]) {
          case 'acao':
            // LIMPA O CAMPO DO RESQUEST
            this.formulario.field.request.value = ''

            // CHAMA A FUNÇÃO PARA VER QUAL CAMPO DEVE MOSTRAR
            this.requestManualCampoMostraOculta()
            break
        }
      },
      requestManualCampoMostraOculta: function () {
        // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
        this.formulario.field.request.mostrar = this.formulario.field.acao.value !== ''

        // VERIFICA SE O BOTÃO DEVE SER APRESENTADO
        this.buttons.buscar.mostrar = this.formulario.field.request.mostrar
        this.buttons.copiar.mostrar = this.formulario.field.request.mostrar

        switch (this.formulario.field.acao.value) {
          case 'emitir':
            this.buttons.buscar.texto = 'Emitir'
            break
        
          default:
            this.buttons.buscar.texto = 'Buscar'
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      requestManualCampoBuscarApi: function () {
        // INICIA AS VARIAVEIS
        var router = ''
        var methods = ''
        var queryGet = {}

        // SETA O VALOR RECEBIDO
        this.buttons.buscar.status = 'carregando'  

        // VERIFICA O MODULO QUE DEVE USAR PARA EMITIR
        var rfMod = ''
        switch (this.$route.name) {
          case 'compra_numero':
            rfMod = '11'
            break
          case 'venda_numero':
            rfMod = '10'
            break
          case 'dev_fornecedor_nova':
          case 'dev_fornecedor_nova_numero':
          case 'dev_fornecedor_numero':
            rfMod = '60'
            break
          case 'dev_cliente_nova':
          case 'dev_cliente_nova_numero':
          case 'dev_cliente_numero':
            rfMod = '59'
            break
        }

        // VERIFICA O TIPO DE DADOS QUE DEVE TRATAR
        switch (this.formulario.field.acao.value) {
          case 'emitir':
            methods = 'PUT'
            router = '/df/reemitir'
            queryGet = { j_df: JSON.stringify([ this.cpntRefId ]), request_manual: this.formulario.field.acao.value, request_manual_xml: this.formulario.field.request.value }
            break
          
          default:
            // SETA O VALOR RECEBIDO
            this.formulario.field.request.value = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // VERIFICA SE O BOTÃO EMITIR EXITE
            if (this.cpntVendaAcoesProduto.emitir !== '0') {
              methods = 'POST'
              router = '/df/emitir'
              queryGet = { j_ref: JSON.stringify([ { tp: 'p', m: rfMod, id: this.cpntRefId, request_manual: this.formulario.field.acao.value } ]), request_manual: this.formulario.field.acao.value }
            } else if (this.cpntVendaAcoesProduto.reemitir !== '0') {
              methods = 'PUT'
              router = '/df/reemitir'
              queryGet = { j_df: JSON.stringify([ this.cpntRefId ]), request_manual: this.formulario.field.acao.value }
            }

            break
        }

        if (router === '') {
          this.$store.state.msgWarn('WEB [500]: Erro ao identificar o tipo de ação que deve ser realizada.', 'danger')
        } else {
          var self = this

          // COMUNICA COM A API
          self.$store.state.comunicaAPI(router, methods, queryGet, function (apiSuccess) {
            // PEGA O VALOR DO LOT RECEBIDO
            var lot = apiSuccess.lot[0]

            if (lot.code !== '200') {
              self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                // SETA O VALOR RECEBIDO
                self.buttons.buscar.status = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            } else {
              switch (self.formulario.field.acao.value) {
                case 'emitir':
                  self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                    // FORÇA A ATUALIZAÇÃO DA TELA
                    self.$store.commit('SET_TIME_CONTEUDO', self.$router.resolve({ name: 'venda_numero', params: { id: self.$route.params.id } }))

                    // FECHA O BOTÃO DE ATALHO SE ELE ESTIVER ABERTO
                    if (self.$store.state.atalhos['ALT+R'].mostrar === true) {
                      self.$store.commit('EXECUTE_ATALHO', 'ALT+R')
                    }
                  })
                  break

                default:
                  // SETA O VALOR RECEBIDO
                  self.buttons.buscar.status = ''
      
                  // SETA O VALOR RECEBIDO
                  self.formulario.field.request.value = lot.data
      
                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
    
                  // APRESENTA A MENSAGEM DE SUCESSO
                  self.$store.state.msgWarn('WEB [200]: Request recebido com sucesso.', 'success')
                  break
              }
            }
          }, self.requestManualStatusGeral, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, '', apiValid, apiStatus, {}, true, function () {
              // SETA O VALOR RECEBIDO
              self.buttons.buscar.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        }
      }
    }
  }
</script>
